import {type UseMutateFunction, useMutation} from "@tanstack/react-query";
import {useAuthStore} from "@/store/auth.store";
import {decodeJwt} from "@/util/jwt";
import {loginService} from "./login.service";
import type {LoginRequest, LoginResult} from "./login.types";

export interface UseLoginResult {
  login: UseMutateFunction<LoginResult, Error, LoginRequest>;
  isPending: boolean;
  isError: boolean;
  error: Error | null;
  reset: () => void;
}

export const useLogin = (): UseLoginResult => {
  const setSession = useAuthStore(state => state.setSession);

  const mutation = useMutation<LoginResult, Error, LoginRequest>({
    mutationKey: ["auth", "login"],
    mutationFn: loginService,
    onSuccess: result => {
      const payload = decodeJwt(result.accessToken);
      setSession({
        token: result.accessToken,
        user: payload ?? {},
      });
    },
  });

  return {
    login: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
};
